import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { getRouterPaths } from "../router/routerPaths";
import { logout } from "../store/features/auth/authSlice";
import { clearUser } from "../store/features/me/userSlice";

export const useLogout = (userType) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const routerPaths = getRouterPaths(userType);

  const handleLogout = () => {
    dispatch(logout());
    dispatch(clearUser());
    navigate(routerPaths.login);
  };

  return { handleLogout, routerPaths };
};
